import { render, staticRenderFns } from "./DetalleColaborador.vue?vue&type=template&id=0a154d3f&scoped=true&"
import script from "./DetalleColaborador.vue?vue&type=script&lang=js&"
export * from "./DetalleColaborador.vue?vue&type=script&lang=js&"
import style0 from "./DetalleColaborador.vue?vue&type=style&index=0&id=0a154d3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a154d3f",
  null
  
)

export default component.exports